export default __webpack_public_path__ + "static/constat_fr-bdcfce20532da2ba6c03014ac60a0178.mp4";